import { c as _c } from "react/compiler-runtime";
import { IcoEyeCrossed16 } from '@onefootprint/icons';
import type { VerifiedChallengeKind } from '@onefootprint/request-types/dashboard';
import { Divider, Form, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
export const DEFAULT_CHALLENGE_KIND: VerifiedChallengeKind = 'dob';
type ChallengeKindForm = {
  challengeKind: VerifiedChallengeKind;
};

/**
 * Employee-only. Picks which field (name / DOB / SSN4) the flow collects and sends as the Verified
 * 1-click challenge input — extra data that helps Verified locate the user. Any kind is valid: the
 * field is a per-request input, so it doesn't depend on the tenant's Verified brand config.
 */
const VerifiedPrefillChallengeKind = t0 => {
  const $ = _c(43);
  const {
    canEdit,
    isFirmEmployee
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "verifiedPrefill.challengeKind"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  if (!isFirmEmployee) {
    return null;
  }
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="text-label-3 text-primary">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex-shrink-0 text-tertiary"><IcoEyeCrossed16 /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <Tooltip content={t4} side="left">{t5}</Tooltip>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div className="flex items-center justify-between gap-2">{t3}{t6}</div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = !canEdit;
  let t9;
  if ($[13] !== t) {
    t9 = t(_temp3);
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = {
      value: "dob",
      label: t9
    };
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t(_temp4);
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = {
      value: "name",
      label: t11
    };
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t(_temp5);
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = {
      value: "ssn4",
      label: t13
    };
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t10 || $[26] !== t12 || $[27] !== t14) {
    t15 = [t10, t12, t14];
    $[25] = t10;
    $[26] = t12;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t8) {
    t16 = <Form.RadioGroup name="challengeKind" disabled={t8} options={t15} />;
    $[29] = t15;
    $[30] = t8;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t) {
    t17 = t(_temp6);
    $[32] = t;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t17) {
    t18 = <p className="text-caption-2 text-tertiary">{t17}</p>;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t16 || $[37] !== t18 || $[38] !== t7) {
    t19 = <div className="flex flex-col gap-2">{t7}{t16}{t18}</div>;
    $[36] = t16;
    $[37] = t18;
    $[38] = t7;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Divider />;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t19) {
    t21 = <>{t19}{t20}</>;
    $[41] = t19;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  return t21;
};
export default VerifiedPrefillChallengeKind;
function _temp($) {
  return $.label;
}
function _temp2($_0) {
  return $_0.employeeOnly;
}
function _temp3($_1) {
  return $_1.kinds.dob;
}
function _temp4($_2) {
  return $_2.kinds.name;
}
function _temp5($_3) {
  return $_3.kinds.ssn4;
}
function _temp6($_4) {
  return $_4.hint;
}